import { AttackPattern, PatternState } from '../AttackPattern.js';
import { ARENA } from '../../../../config/constants.js';

/**
 * Cross Beam Sweep — exclusive to Ashen Throne. A full-arena telegraphed
 * cross (one beam spanning the entire width, one spanning the entire
 * height) anchored on the player's position at telegraph start, then both
 * beams go live at once. Specifically built around the Phase A rectangular
 * arena being bigger than one screen: the beams span the whole rect, not
 * just the boss's immediate vicinity, so running away from the boss alone
 * doesn't dodge it — the player has to actually clear the anchor lines.
 *
 * `config` (tickDamage/tickInterval/thickness) is per-boss tuning, supplied
 * by data/bosses.js.
 */
export class CrossBeamSweep extends AttackPattern {
  constructor({ minPhase = 2, config }) {
    super({ name: 'Cross Beam Sweep', telegraphDuration: 0.9, activeDuration: 1.1, minPhase, arenaControl: true });
    this.config = config;
  }

  onBegin(_boss, player) {
    this._centerX = player.x;
    this._centerY = player.y;
    this._tickTimer = 0;
  }

  onActiveTick(dt, _boss, player) {
    const { tickDamage, tickInterval, thickness } = this.config;
    this._tickTimer -= dt;
    const inHorizontal = Math.abs(player.y - this._centerY) < thickness / 2 + player.radius;
    const inVertical = Math.abs(player.x - this._centerX) < thickness / 2 + player.radius;
    if (this._tickTimer <= 0 && (inHorizontal || inVertical)) {
      player.takeDamage(tickDamage);
      this._tickTimer = tickInterval;
    }
  }

  getVisual() {
    if (this.state === PatternState.TELEGRAPH || this.state === PatternState.ACTIVE) {
      return {
        kind: 'crossBeam',
        x: this._centerX,
        y: this._centerY,
        thickness: this.config.thickness,
        imminent: this.state === PatternState.ACTIVE,
      };
    }
    return null;
  }
}
